var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrainLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1584",
    "data-name": "Group 1584",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 262.169,
    height: 40,
    viewBox: "0 0 262.169 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 262.169,
    height: 40,
    fill: "rgba(0,0,0,0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M103.144,47.362l-.257,1.261h2.745L104.16,55.7h1.46l1.472-7.08h2.652l.268-1.261Z",
    transform: "translate(-33.797 -15.943)",
    fill: "#63656a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M113.092,47.362h1.265l-.621,3h.022a2.439,2.439,0,0,1,1.886-.966c1.155,0,1.676.6,1.676,1.521a3.764,3.764,0,0,1-.055.71l-.767,3.661h-1.264l.732-3.54a2.548,2.548,0,0,0,.089-.533c0-.189.044-.822-.876-.822a1.681,1.681,0,0,0-1.2.555,2.66,2.66,0,0,0-.621,1.233l-.644,3.107H111.45Z",
    transform: "translate(-36.505 -15.513)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M125.221,52.9c.011-.132.011-.243.011-.354a1.119,1.119,0,0,0-1.209-1.165,1.8,1.8,0,0,0-1.743,1.52Zm.921,1.6a2.612,2.612,0,0,1-2.763,1.931,2.37,2.37,0,0,1-2.508-2.508,3.3,3.3,0,0,1,3.185-3.54c2.042,0,2.441,1.521,2.441,2.641a4.029,4.029,0,0,1-.066.71h-4.273a2.17,2.17,0,0,0-.022.367A1.215,1.215,0,0,0,123.5,55.43a1.331,1.331,0,0,0,1.376-.932Z",
    transform: "translate(-39.591 -16.502)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M135.834,50.68h2.075c1.376,0,1.576-.822,1.576-1.243,0-.321-.089-.943-1.222-.943h-1.975Zm-.722,3.473H137.1c.466,0,1.931.067,2.053-1.231.044-.377,0-1.243-1.421-1.243h-2.1Zm.023-6.791h3.417c2.1,0,2.32,1.276,2.32,1.853a1.842,1.842,0,0,1-1.52,1.887v.022a1.579,1.579,0,0,1,1.187,1.664c0,.822-.522,2.5-2.974,2.5h-4.074Z",
    transform: "translate(-43.725 -15.513)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M146.923,50.968h2.03c1.176,0,1.843-.522,1.843-1.443,0-.865-.688-1.032-1.421-1.032h-1.941Zm-.666-3.606h3.429c.677,0,2.5.089,2.5,2.019a1.993,1.993,0,0,1-1.8,2.153v.022a1.325,1.325,0,0,1,.844,1.432c0,.543-.134,1.1-.122,1.643a1.228,1.228,0,0,0,.144.654H149.8a1.866,1.866,0,0,1-.089-.61c0-.588.133-1.155.133-1.732,0-.921-.742-.921-1.487-.921H146.7l-.676,3.263h-1.409Z",
    transform: "translate(-47.368 -15.513)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M160.368,48.76h-.022l-1.909,3.374h2.419Zm-.477-1.4h1.465l1.376,7.923h-1.409l-.322-2.1H157.85l-1.22,2.1h-1.487Z",
    transform: "translate(-50.817 -15.513)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M169.071,47.362h1.387L168.8,55.285h-1.387Z",
    transform: "translate(-54.838 -15.513)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M173.351,47.362h1.52l2.43,5.914h.023l1.21-5.914h1.387l-1.642,7.923h-1.52L174.316,49.4h-.023l-1.2,5.882h-1.387Z",
    transform: "translate(-56.243 -15.513)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M188.756,47.362h1.387l-1.654,7.923H187.1Z",
    transform: "translate(-61.285 -15.513)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M192.2,50.537h1.188l-.179.832.023.022a2.429,2.429,0,0,1,1.975-1.009c1.155,0,1.676.6,1.676,1.52a3.757,3.757,0,0,1-.055.71l-.766,3.661H194.8l.733-3.539a2.548,2.548,0,0,0,.089-.533c0-.19.044-.822-.877-.822a1.677,1.677,0,0,0-1.2.555,2.656,2.656,0,0,0-.622,1.232l-.643,3.107h-1.265Z",
    transform: "translate(-62.566 -16.503)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M202.043,47.363H203.3l-.245,1.2H201.8Zm-.455,2.185h1.266l-1.187,5.737H200.4Z",
    transform: "translate(-65.641 -15.514)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M206.359,48.055h1.233l-.356,1.72h1.143l-.2.942h-1.144l-.588,2.809a3.724,3.724,0,0,0-.11.621c0,.243.077.422.455.422a2.974,2.974,0,0,0,.676-.056l-.211.933a4.8,4.8,0,0,1-1.043.122c-.91,0-1.144-.533-1.144-1.066a3.817,3.817,0,0,1,.078-.643l.655-3.142h-1l.2-.942h1Z",
    transform: "translate(-67.084 -15.74)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M211.349,47.363H212.6l-.245,1.2H211.1Zm-.455,2.185h1.266l-1.188,5.737h-1.265Z",
    transform: "translate(-68.69 -15.514)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M215.925,55.43c1.233,0,1.642-.888,1.809-1.975l-.022-.023a1.4,1.4,0,0,1-.788.267c-.71.055-2.009.044-2.009,1,0,.555.543.732,1.009.732m2.8-.822a3.371,3.371,0,0,0-.112.566c0,.156.067.256.267.256.144,0,.3-.055.444-.067l-.2.91a4.284,4.284,0,0,1-.988.155.732.732,0,0,1-.765-.733,2.744,2.744,0,0,1-1.931.733,1.6,1.6,0,0,1-1.786-1.532c0-1.408,1.142-1.9,2.407-1.975.422-.023.855-.067,1.266-.1a.671.671,0,0,0,.665-.754c0-.543-.443-.689-.965-.689-.688,0-1.254.19-1.432.9h-1.2c.278-1.421,1.344-1.9,2.708-1.9,2.087,0,2.153.921,2.153,1.331a4.029,4.029,0,0,1-.111.866Z",
    transform: "translate(-69.981 -16.502)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M224.756,48.055h1.233l-.356,1.72h1.143l-.2.942h-1.144l-.588,2.809a3.723,3.723,0,0,0-.11.621c0,.243.077.422.455.422a2.974,2.974,0,0,0,.676-.056l-.211.933a4.8,4.8,0,0,1-1.043.122c-.91,0-1.144-.533-1.144-1.066a3.817,3.817,0,0,1,.078-.643l.655-3.142h-1l.2-.942h1Z",
    transform: "translate(-73.11 -15.74)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M229.746,47.363H231l-.245,1.2H229.5Zm-.455,2.185h1.266l-1.188,5.737H228.1Z",
    transform: "translate(-74.716 -15.514)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M232.757,50.613h1.309l.477,4.183h.022l2.22-4.183h1.331l-3.174,5.737h-1.408Z",
    transform: "translate(-76.239 -16.578)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M244.547,52.9c.011-.132.011-.243.011-.354a1.119,1.119,0,0,0-1.209-1.165,1.8,1.8,0,0,0-1.743,1.52Zm.921,1.6a2.612,2.612,0,0,1-2.763,1.931,2.37,2.37,0,0,1-2.508-2.508,3.3,3.3,0,0,1,3.184-3.54c2.042,0,2.441,1.521,2.441,2.641a4.027,4.027,0,0,1-.066.71h-4.273a2.168,2.168,0,0,0-.022.367,1.215,1.215,0,0,0,1.366,1.332A1.331,1.331,0,0,0,244.2,54.5Z",
    transform: "translate(-78.677 -16.502)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M250.357,49.989c.149,0,.288-.015.288-.191,0-.141-.15-.165-.27-.165h-.247v.356Zm-.23.691h-.194V49.463h.462c.293,0,.443.1.443.35a.31.31,0,0,1-.317.332l.341.535h-.227l-.314-.52h-.194Zm.224-1.537a.911.911,0,1,0,.841.908.854.854,0,0,0-.841-.908m0,2.007a1.1,1.1,0,1,1,1.076-1.1,1.059,1.059,0,0,1-1.076,1.1",
    transform: "translate(-81.648 -16.034)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M103.046,21.184h2.1l5.193,8.479h.032V21.184h1.895v11.51h-2.1l-5.175-8.462h-.048v8.462h-1.9Z",
    transform: "translate(-33.753 -6.939)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M126.092,32.277c0,.451.1.628.43.628a2.465,2.465,0,0,0,.445-.032v1.274a4.558,4.558,0,0,1-1.145.208c-.734,0-1.259-.258-1.4-1.014a4.2,4.2,0,0,1-2.851,1.014c-1.481,0-2.82-.806-2.82-2.433,0-2.08,1.64-2.419,3.171-2.6,1.305-.242,2.467-.1,2.467-1.175,0-.952-.972-1.129-1.7-1.129-1.019,0-1.735.42-1.816,1.322h-1.815c.126-2.144,1.926-2.774,3.742-2.774,1.609,0,3.3.662,3.3,2.419Zm-1.816-2.322a6.43,6.43,0,0,1-2.23.5c-.78.128-1.481.418-1.481,1.385,0,.822,1.035,1.064,1.672,1.064.8,0,2.038-.42,2.038-1.58Z",
    transform: "translate(-38.897 -8.375)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M130.879,24.689h1.37v-2.5h1.816v2.5h1.64v1.37h-1.64v4.449c0,.759.064,1.146.876,1.146a3.029,3.029,0,0,0,.765-.065v1.418c-.4.033-.779.1-1.178.1-1.9,0-2.247-.741-2.278-2.128V26.06h-1.37Z",
    transform: "translate(-42.869 -7.269)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M139.6,21.184h1.816v1.741H139.6Zm0,3.175h1.816v8.334H139.6Z",
    transform: "translate(-45.725 -6.939)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M144.19,29.956c0-2.547,1.513-4.385,4.157-4.385s4.156,1.838,4.156,4.385c0,2.564-1.513,4.4-4.156,4.4s-4.157-1.836-4.157-4.4m6.5,0c0-1.434-.717-2.935-2.342-2.935s-2.341,1.5-2.341,2.935c0,1.45.717,2.949,2.341,2.949s2.342-1.5,2.342-2.949",
    transform: "translate(-47.229 -8.376)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M158.332,25.8h1.719v1.225l.032.032a2.943,2.943,0,0,1,2.564-1.483,2.619,2.619,0,0,1,2.914,2.838V34.13h-1.815V28.892c-.032-1.307-.543-1.871-1.608-1.871a2.022,2.022,0,0,0-1.991,2.194V34.13h-1.816Z",
    transform: "translate(-51.862 -8.375)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M178.133,32.277c0,.451.1.628.43.628a2.468,2.468,0,0,0,.446-.032v1.274a4.559,4.559,0,0,1-1.146.208c-.733,0-1.259-.258-1.4-1.014a4.2,4.2,0,0,1-2.85,1.014c-1.481,0-2.82-.806-2.82-2.433,0-2.08,1.64-2.419,3.17-2.6,1.306-.242,2.468-.1,2.468-1.175,0-.952-.972-1.129-1.7-1.129-1.02,0-1.736.42-1.816,1.322h-1.816c.128-2.144,1.927-2.774,3.743-2.774,1.609,0,3.3.662,3.3,2.419Zm-1.816-2.322a6.423,6.423,0,0,1-2.23.5c-.78.128-1.481.418-1.481,1.385,0,.822,1.036,1.064,1.673,1.064.8,0,2.038-.42,2.038-1.58Z",
    transform: "translate(-55.943 -8.375)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 1.816,
    height: 11.51,
    transform: "translate(123.88 14.245)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 1.991,
    height: 11.51,
    transform: "translate(131.717 14.245)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M201.608,25.8h1.719v1.225l.032.032a2.942,2.942,0,0,1,2.564-1.483,2.619,2.619,0,0,1,2.914,2.838V34.13h-1.815V28.892c-.032-1.307-.543-1.871-1.609-1.871a2.022,2.022,0,0,0-1.991,2.194V34.13h-1.816Z",
    transform: "translate(-66.037 -8.375)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M215.884,31.455c.1,1.064.892,1.45,1.863,1.45.685,0,1.879-.145,1.832-1.1-.048-.967-1.37-1.079-2.691-1.387-1.339-.288-2.644-.773-2.644-2.466,0-1.821,1.943-2.386,3.44-2.386,1.689,0,3.218.71,3.441,2.563h-1.9c-.159-.87-.876-1.111-1.672-1.111-.525,0-1.5.128-1.5.854,0,.9,1.338,1.032,2.675,1.339s2.66.789,2.66,2.434c0,1.982-1.975,2.707-3.679,2.707-2.07,0-3.616-.935-3.647-2.9Z",
    transform: "translate(-70.118 -8.375)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M225.319,24.689h1.37v-2.5H228.5v2.5h1.64v1.37H228.5v4.449c0,.759.064,1.146.876,1.146a3.029,3.029,0,0,0,.765-.065v1.418c-.4.033-.78.1-1.178.1-1.9,0-2.247-.741-2.278-2.128V26.06h-1.37Z",
    transform: "translate(-73.803 -7.269)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M234.035,21.184h1.816v1.741h-1.816Zm0,3.175h1.816v8.334h-1.816Z",
    transform: "translate(-76.658 -6.939)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M237.968,24.689h1.37v-2.5h1.816v2.5h1.64v1.37h-1.64v4.449c0,.759.064,1.146.876,1.146a3.034,3.034,0,0,0,.765-.065v1.418c-.4.033-.78.1-1.178.1-1.9,0-2.247-.741-2.278-2.128V26.06h-1.37Z",
    transform: "translate(-77.946 -7.269)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M253.844,34.24h-1.783V33.08h-.032a2.76,2.76,0,0,1-2.341,1.386c-2.151,0-3.074-1.1-3.074-3.272V25.906h1.815v5.111c0,1.467.59,2,1.577,2,1.513,0,2.023-.982,2.023-2.273V25.906h1.816Z",
    transform: "translate(-80.779 -8.486)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M258.5,24.689h1.37v-2.5h1.816v2.5h1.641v1.37H261.69v4.449c0,.759.064,1.146.876,1.146a3.042,3.042,0,0,0,.765-.065v1.418c-.4.033-.781.1-1.179.1-1.9,0-2.247-.741-2.278-2.128V26.06H258.5Z",
    transform: "translate(-84.673 -7.269)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M268.374,30.44a2.207,2.207,0,0,0,2.214,2.466A1.911,1.911,0,0,0,272.6,31.52h1.72a3.614,3.614,0,0,1-3.727,2.836c-2.58,0-4.03-1.822-4.03-4.385,0-2.369,1.528-4.4,3.982-4.4,2.6,0,4.189,2.37,3.887,4.869Zm4.235-1.208a2.12,2.12,0,1,0-4.235,0Z",
    transform: "translate(-87.311 -8.376)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M281,31.455c.1,1.064.892,1.45,1.864,1.45.685,0,1.879-.145,1.83-1.1-.046-.967-1.368-1.079-2.691-1.387-1.338-.288-2.643-.773-2.643-2.466,0-1.821,1.943-2.386,3.44-2.386,1.688,0,3.217.71,3.44,2.563h-1.895c-.159-.87-.876-1.111-1.672-1.111-.526,0-1.5.128-1.5.854,0,.9,1.338,1.032,2.675,1.339s2.661.789,2.661,2.434c0,1.982-1.976,2.707-3.68,2.707-2.071,0-3.615-.935-3.647-2.9Z",
    transform: "translate(-91.447 -8.375)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M297.208,29.956c0-2.547,1.514-4.385,4.158-4.385s4.157,1.838,4.157,4.385c0,2.564-1.514,4.4-4.157,4.4s-4.158-1.836-4.158-4.4m6.5,0c0-1.434-.716-2.935-2.341-2.935s-2.342,1.5-2.342,2.935c0,1.45.718,2.949,2.342,2.949s2.341-1.5,2.341-2.949",
    transform: "translate(-97.351 -8.376)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M310.142,24.359H311.5v-.693c0-2.128,1.1-2.483,2.278-2.483a5.09,5.09,0,0,1,1.275.113v1.435a3.028,3.028,0,0,0-.844-.1c-.495,0-.893.177-.893.871v.853h1.545v1.37h-1.545v6.964H311.5V25.73h-1.354Z",
    transform: "translate(-101.587 -6.939)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M324.758,21.184h1.991v4.578h5.175V21.184h1.991v11.51h-1.991V27.5h-5.175v5.191h-1.991Z",
    transform: "translate(-106.375 -6.939)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M342.3,30.44a2.206,2.206,0,0,0,2.214,2.466,1.911,1.911,0,0,0,2.007-1.385h1.719a3.613,3.613,0,0,1-3.727,2.836c-2.58,0-4.03-1.822-4.03-4.385,0-2.369,1.528-4.4,3.982-4.4,2.6,0,4.19,2.37,3.886,4.869Zm4.236-1.208a2.12,2.12,0,1,0-4.236,0Z",
    transform: "translate(-111.526 -8.376)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M360.452,32.277c0,.451.1.628.43.628a2.486,2.486,0,0,0,.447-.032v1.274a4.558,4.558,0,0,1-1.146.208c-.733,0-1.258-.258-1.4-1.014a4.2,4.2,0,0,1-2.85,1.014c-1.483,0-2.82-.806-2.82-2.433,0-2.08,1.641-2.419,3.17-2.6,1.305-.242,2.469-.1,2.469-1.175,0-.952-.972-1.129-1.705-1.129-1.018,0-1.737.42-1.816,1.322h-1.816c.129-2.144,1.929-2.774,3.744-2.774,1.608,0,3.3.662,3.3,2.419Zm-1.816-2.322a6.426,6.426,0,0,1-2.23.5c-.781.128-1.481.418-1.481,1.385,0,.822,1.036,1.064,1.672,1.064.8,0,2.039-.42,2.039-1.58Z",
    transform: "translate(-115.661 -8.375)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 1.816,
    height: 11.51,
    transform: "translate(246.48 14.245)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M370.473,24.689h1.37v-2.5h1.816v2.5h1.64v1.37h-1.64v4.449c0,.759.064,1.146.875,1.146a3.035,3.035,0,0,0,.765-.065v1.418c-.4.033-.779.1-1.179.1-1.9,0-2.245-.741-2.276-2.128V26.06h-1.37Z",
    transform: "translate(-121.349 -7.269)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M379.118,21.184h1.816v4.271h.032a2.878,2.878,0,0,1,2.469-1.322,2.619,2.619,0,0,1,2.915,2.838v5.723h-1.816V27.455c-.032-1.307-.541-1.871-1.609-1.871a2.022,2.022,0,0,0-1.991,2.193v4.916h-1.816Z",
    transform: "translate(-124.18 -6.939)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M55.477,19.983,44.417,0H3.682A3.682,3.682,0,0,0,0,3.683V36.317A3.682,3.682,0,0,0,3.682,40h40.7Zm-34.777,9H17.394L9.255,15.836H9.18V28.984H6.2V11.1H9.506l8.163,13.173h.051V11.1H20.7Zm6.214,0H23.783V11.1h3.131ZM44.446,11.1V28.984H41.315V20.92H33.176v8.065H30.045V11.1h3.131v7.113h8.139V11.1Z",
    transform: "translate(0 0)",
    fill: "#63656a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M70.123,40,81.208,19.983,70.16,0h2.766a5.167,5.167,0,0,1,4.085,2.409l9.716,17.574L76.978,37.591A5.165,5.165,0,0,1,72.891,40Z",
    transform: "translate(-22.969 0)",
    fill: "#215482"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainLogo);
export default __webpack_public_path__ + "static/media/brain_logo.d23a272778ea8aed6e3ebbe0982505ea.svg";
export { ForwardRef as ReactComponent };